/*
 * Copyright (c) 2020 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */

import {IComponentOptions, IHttpService, IScope} from 'angular';
import TSSchaden from '../../../models/TSSchaden';
import TSGeoadminSearchResponse from '../../../models/TSGeoadminSearchResponse';
import ILogService = angular.ILogService;

declare let require: any;
declare let angular: any;
require('./dv-geoadmin-search.scss');

export class GeoAdminSearchComponentConfig implements IComponentOptions {
    transclude = false;
    bindings: any = {
        schaden: '=',
        readonly: '<',
        formschaden: '=',
    };
    template = require('./dv-geoadmin-search.html');
    controller = DvGeoAdminSearchController;
    controllerAs = 'vm';
    require: any = {parentForm: '?^form'};
}

export class DvGeoAdminSearchController {

    static $inject = ['$log', '$http', '$scope'];

    schaden: TSSchaden;
    readonly: boolean;
    formschaden: any;

    asyncSelected: TSGeoadminSearchResponse;

    constructor(private $log: ILogService, private $http: IHttpService, private $scope: IScope) {
    }

    $onInit() {

        this.asyncSelected = new TSGeoadminSearchResponse();
        if (this.schaden.schadenDatenFS && this.schaden.schadenDatenFS.ort) {
            // @ts-ignore
            this.asyncSelected = this.schaden.schadenDatenFS.ort;
        } else {
            // @ts-ignore
            this.asyncSelected = ''
        }

        /*set position if value has changed*/
        this.$scope.$watch(() => {
            return this.asyncSelected;
        }, (newValue, oldValue) => {
            if (newValue && newValue.lat && newValue.lon && (newValue !== oldValue)) {
                this.getModel().schadenDatenFS.mapLatitude = Number(newValue.lat);
                this.getModel().schadenDatenFS.mapLongitude = Number(newValue.lon);
                this.getModel().schadenDatenFS.ort = newValue.name;
            } else {
                // @ts-ignore
                this.getModel().schadenDatenFS.ort = this.asyncSelected;
                console.log(this.getModel().schadenDatenFS.ort);
            }

        });

    }

    private loadSuggestElements(searchString: string): any {
        return this.$http.get(`https://api3.geo.admin.ch/rest/services/api/SearchServer?sr=2056&searchText=${encodeURIComponent(searchString)}&type=locations`).then(function (response) {
            // @ts-ignore
            return response.data.results.map((res: any) => {
                return new TSGeoadminSearchResponse().deserialize(res.attrs);
            });
        });

    }

    private getModel(): TSSchaden {
        return this.schaden;
    }

}




// WEBPACK FOOTER //
// ./src/app/core/component/dv-geoadmin-search/dv-geoadmin-search.ts